import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'gatsby'
import { FaAngleRight } from '@react-icons/all-files/fa/FaAngleRight'
import { Email } from '../../../icons'
import AppButtonV3 from './AppButtonV3'
import ApplyParamsContext from '../../../../context/ApplyParamsContext'
import { reloadIfCurrentRoute } from '../../../../helpers/pageUtils'
import { getExistingAttributionParams } from '../../../../helpers'

function ContentfulButtonText({ text, toLowerCase }) {
  const transformedText = !toLowerCase || toLowerCase === null ? text?.toUpperCase() : text
  if (transformedText?.length && transformedText.includes('|')) {
    const [inactive, active] = transformedText.split('|')
    return (
      <>
        <span className="inactive">{inactive}</span>
        <span className="active">{active}</span>
      </>
    )
  }
  return <span>{transformedText}</span>
}

ContentfulButtonText.defaultProps = {
  text: '',
  toLowerCase: false
}

ContentfulButtonText.propTypes = {
  text: PropTypes.string,
  toLowerCase: PropTypes.bool
}

function ContentfulButtonV3({
  data,
  parentComponent,
  isMain,
  onMouseOver,
  grid,
  oldPimary,
  odsData
}) {
  const {
    style,
    hasEmailIcon,
    text,
    action,
    url,
    contentfulAsset,
    openNewWindow,
    dataEvent,
    pageCategory,
    segmentEvent,
    removeArrowIcon,
    textToLowercase,
    payload
  } = data

  const payloadJSON = payload ? JSON.parse(payload.internal.content) : {}
  let buttonClass = ['button']
  const emailIcon = hasEmailIcon ? (
    <Email
      className={`button-group__icon button-group__icon-${style.toLowerCase()}`}
      title="email button"
    />
  ) : null
  const styleToCssClass = {
    Primary: 'button--primary',
    Secondary: 'button--secondary',
    Tertiary: 'button--tertiary'
  }

  if (grid) buttonClass.push('button--grid-card')

  buttonClass.push(styleToCssClass[style])

  if (oldPimary) {
    buttonClass.push('button--primary')
  }

  if (isMain) buttonClass.push('carousel-main')

  buttonClass = buttonClass.join(' ')

  const productTypes = {
    Banking: { id: 'banking' },
    'Personal Loans Application': { id: 'installment', endpoint: 'apply' },
    'Credit Card Application': { id: 'credit_card', endpoint: 'apply' },
    'MLS Application': { id: 'mls', endpoint: 'credit_card/apply' }
  }

  const testId = text.toLowerCase().replace(/\s/g, '')

  let arrowIcon
  if (!removeArrowIcon || removeArrowIcon === null) {
    arrowIcon = <FaAngleRight className="arrow-right" title={text.toLowerCase()} role="img" />
  }

  // TODO: refactor with useContext hook
  return (
    <ApplyParamsContext.Consumer>
      {applyParams => {
        if (productTypes[action]) {
          const dynamicApplyParamsHistory = getExistingAttributionParams()
          // take all params from url that's whitelisted in dynamicapplyparams
          // put them in extraapplyparams
          const { dynamicApplyParams } = applyParams
          let { extraApplyParams } = applyParams

          if (typeof window !== 'undefined') {
            const windowSearchUrl = window.location.search
            const searchParams = new URLSearchParams(windowSearchUrl)
            if (!extraApplyParams) {
              extraApplyParams = {}
            }
            const extraLowerToCapital = {} // lower case to capital map
            Object.keys(extraApplyParams).map(el => (extraLowerToCapital[el.toLowerCase()] = el))

            if (applyParams.dynamicApplyParams) {
              const dynamicLowerToCapital = {} // lower case to capital map, key: lowercase, value: proper case
              dynamicApplyParams.map(el => (dynamicLowerToCapital[el.toLowerCase()] = el))
              Array.from(searchParams).forEach(pair => {
                const [key, value] = pair
                const keyLower = key.toLowerCase()
                const keyInExtra = extraLowerToCapital[keyLower]
                const capitalKey = dynamicLowerToCapital[keyLower]
                if (capitalKey && !keyInExtra) {
                  extraApplyParams[capitalKey] = value
                }
              })
            }

            if (dynamicApplyParamsHistory) {
              Object.keys(dynamicApplyParamsHistory).forEach(key => {
                const keyLower = key.toLowerCase()
                const keyInExtra = extraLowerToCapital[keyLower]
                if (!keyInExtra) {
                  extraApplyParams[key] = dynamicApplyParamsHistory[key]
                }
              })
            }
          }

          return (
            <AppButtonV3
              className={odsData ? style : buttonClass}
              dataEvent={dataEvent}
              productType={productTypes[action]}
              pageCategory={pageCategory || ''}
              landingKeyword={extraApplyParams?.landing_keyword ?? null}
              extraApplyParams={extraApplyParams}
              odsData={odsData}
              onMouseOver={onMouseOver}
              segmentEvent={segmentEvent}
              text={text}
              buttonUrl={url}
              parentComponent={parentComponent}
              payloadJSON={payloadJSON}
              testId={testId}
            >
              {arrowIcon}
              {emailIcon}
              <ContentfulButtonText text={text} toLowerCase={textToLowercase} />
            </AppButtonV3>
          )
        }

        if (action === 'Email TextBox' || action?.[0] === 'Email TextBox') {
          return (
            <input
              type="text"
              placeholder={text || ''}
              name="get_started_email"
              className="textbox"
              onMouseOver={onMouseOver}
              onFocus={onMouseOver}
            />
          )
        }

        if (
          (action === 'Contentful Asset' || action?.[0] === 'Contentful Asset') &&
          contentfulAsset?.file
        ) {
          return (
            <a
              href={contentfulAsset.file.url}
              download={contentfulAsset.file.filename}
              target="_blank"
              rel="noreferrer"
              className={buttonClass}
              onMouseOver={onMouseOver}
              onFocus={onMouseOver}
              data-test-id={testId}
            >
              {arrowIcon}
              {emailIcon}
              <ContentfulButtonText text={text} toLowerCase={textToLowercase} />
            </a>
          )
        }

        if (openNewWindow) {
          // "Open URL"
          return (
            <a
              data-test-id={testId}
              href={url}
              target="_blank"
              rel="noreferrer"
              className={buttonClass}
              onMouseOver={onMouseOver}
              onFocus={onMouseOver}
              onClick={() => {
                if (segmentEvent && window.analytics) {
                  window.analytics.track(segmentEvent, {
                    location: parentComponent,
                    text,
                    destination: url,
                    url: window.location.href,
                    ...payloadJSON
                  })
                }
              }}
            >
              {arrowIcon}
              {emailIcon}
              <ContentfulButtonText text={text} toLowerCase={textToLowercase} />
            </a>
          )
        }
        if (url?.startsWith('http')) {
          return (
            <a
              href={url}
              rel="noreferrer"
              className={buttonClass}
              onMouseOver={onMouseOver}
              onFocus={onMouseOver}
              onClick={() => {
                if (segmentEvent && window.analytics) {
                  window.analytics.track(segmentEvent, {
                    location: parentComponent,
                    text,
                    destination: url,
                    url: window.location.href,
                    ...payloadJSON
                  })
                }
              }}
            >
              {arrowIcon}
              {emailIcon}
              <ContentfulButtonText text={text} toLowerCase={textToLowercase} />
            </a>
          )
        }
        return (
          <Link
            to={url}
            data-test-id={testId}
            className={buttonClass}
            onClick={() => {
              if (segmentEvent && window.analytics) {
                window.analytics.track(segmentEvent, {
                  location: parentComponent,
                  text,
                  destination: `${process.env.GATSBY_BASE_URL}${url}`,
                  url: window.location.href,
                  ...payloadJSON
                })
              }
              reloadIfCurrentRoute(url)
            }}
            onMouseOver={onMouseOver}
          >
            {arrowIcon}
            {emailIcon}
            <ContentfulButtonText text={text} toLowerCase={textToLowercase} />
          </Link>
        )
      }}
    </ApplyParamsContext.Consumer>
  )
}

ContentfulButtonV3.defaultProps = {
  oldPimary: false,
  isMain: false,
  onMouseOver: null,
  odsData: undefined,
  grid: false,
  parentComponent: ''
}

ContentfulButtonV3.propTypes = {
  data: PropTypes.object.isRequired,
  oldPimary: PropTypes.bool,
  isMain: PropTypes.bool,
  onMouseOver: PropTypes.func,
  odsData: PropTypes.func,
  grid: PropTypes.bool,
  parentComponent: PropTypes.string
}

export default ContentfulButtonV3
